import { getApiBase } from "./env";

const API_ENDPOINT = getApiBase();

let accessToken: string | null = null;

export function setAccessToken(token: string | null) {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function clearAccessToken() {
  accessToken = null;
}

export async function exchangeToken(firebaseToken: string): Promise<{ accessToken: string; expiresIn: number }> {
  const response = await fetch(`${API_ENDPOINT}/auth/token/exchange`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${firebaseToken}`,
      "X-Portal": "ANALYTICS",
    },
    credentials: "include",
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(error.error || error.message || "Token exchange failed");
  }

  const result = await response.json();
  return result.data;
}

export async function refreshAccessToken(): Promise<{ accessToken: string; expiresIn: number }> {
  const response = await fetch(`${API_ENDPOINT}/auth/token/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Token refresh failed");
  }

  const result = await response.json();
  return result.data;
}

export async function revokeToken(): Promise<void> {
  await fetch(`${API_ENDPOINT}/auth/token/revoke`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    credentials: "include",
  });
}

export interface SessionUser {
  id: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  type: string;
}

export async function fetchSelf(): Promise<SessionUser | null> {
  const response = await fetch(`${API_ENDPOINT}/users/me`, {
    method: "GET",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      "X-Portal": "ANALYTICS",
    },
    credentials: "include",
  });

  if (response.status === 401 || response.status === 403) {
    return null;
  }

  if (!response.ok) {
    throw new Error("Failed to fetch user profile");
  }

  const result = await response.json();
  return result.data ?? null;
}
